import { render } from "./EnableSriovGpuDevice.vue?vue&type=template&id=76910268&scoped=true"
import script from "./EnableSriovGpuDevice.vue?vue&type=script&lang=js"
export * from "./EnableSriovGpuDevice.vue?vue&type=script&lang=js"

import "./EnableSriovGpuDevice.vue?vue&type=style&index=0&id=76910268&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76910268"]])

export default __exports__